import React from 'react';
import PropTypes from 'prop-types';
import { APP_TYPE_DEFAULT } from 'platform/forms-system/src/js/constants';

/**
 * Slim Review & Submit notice shown above the mailing address card when the
 * pattern's on-mount profile sync has replaced the mailing address the user
 * last saved with a newer VA Profile address. The card below shows the
 * updated address itself, so this is a one-line announcement — nothing needs
 * fixing.
 *
 * @param {Object} props
 * @param {string} [props.appType] - "form" / "application" / "claim" wording
 */
const ProfileAddressUpdatedAlert = ({ appType = APP_TYPE_DEFAULT }) => (
  <va-alert
    slim
    status="info"
    class="vads-u-margin-bottom--3"
    data-testid="profile-address-updated-alert"
  >
    <p className="vads-u-margin--0">
      We updated your address in this {appType} to match the address saved in
      your VA.gov profile.
    </p>
  </va-alert>
);

ProfileAddressUpdatedAlert.propTypes = {
  appType: PropTypes.string,
};

export default ProfileAddressUpdatedAlert;
